import React, { useEffect } from "react";
import SelectDropdown from "../../components-react/SelectDropdown";
import { useSelector, useDispatch } from "react-redux";
import { fetchInHouseUsersData } from "../../../redux/reducers/dropdownApiSlice";

const SalesExecutiveFilter = ({
  selectedExecutive,
  setSelectedExecutive,
  gym_id,
}) => {
  const dispatch = useDispatch();
  const { userInfoData } = useSelector((state) => state.user);

  const { inhouseUsers } = useSelector((state) => state.dropdown);

  useEffect(() => {
    dispatch(
      fetchInHouseUsersData({
        token: userInfoData?.token,
        qps: `user_types=receptionist&gym_id=${gym_id}`,
        pageNo: 1,
        limit: 100,
      })
    );
  }, [dispatch, userInfoData?.token, gym_id]);

  return (
    <div className="timesheet_dropdown_wrapper">
      <SelectDropdown
        options={inhouseUsers?.length > 0 ? inhouseUsers : []}
        name="Sales Executive"
        value={selectedExecutive}
        setSelectedOption={setSelectedExecutive}
        isDisable={false}
        isSearchable={true}
        preventKeyboardOpen={true}
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
    </div>
  );
};

export default SalesExecutiveFilter;
